import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css'
import './assets/css/responsive.css'
import '@fortawesome/fontawesome-free/css/all.min.css';
import Header from './components/Header.jsx'
import Footer from './components/Footer.jsx';
import Home from './pages/Home.jsx';
import AboutUsPage from './pages/AboutUsPage.jsx';
import UpcomingEventsPage from './pages/UpcomingEventspage.jsx';
import UpcomingEventDetailPage from './components/EventDetailPage.jsx';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import PastEventspage from './pages/PastEventspage.jsx';
import CommunityPage from './pages/CommunityPage.jsx';
import PartnerWithUs from './pages/PartnerPage.jsx';
import api from '../config.js';
import axios from 'axios';
import EventDetailPage from './components/EventDetailPage.jsx';
import ThankYouPage from './components/ThankYouPage.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import AdvisoryCouncilPage from './pages/AdvisoryCouncilPage.jsx';


function App() {
  axios.defaults.baseURL = api.API_URL;

  return (
    <>
    
    <div>
      <BrowserRouter> 
        <Header />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path="*" element={<Navigate to="/" replace/> } />
          <Route path='/about-us' element={<AboutUsPage />} />
          <Route path='/upcoming-events' element={<UpcomingEventsPage />} />
          <Route path='/event/:slug' element={<EventDetailPage />} />
          <Route path='/past-events' element={<PastEventspage />} />
          <Route path= '/community' element={<CommunityPage />} />
          <Route path= '/partner-with-us' element={<PartnerWithUs />} />
          <Route path= '/thank-you' element={<ThankYouPage />} />
          <Route path= '/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/advisory-council' element={<AdvisoryCouncilPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      </div>
    </>
  )
}

export default App
